"use strict";

var config = require("config");

(function (angular) {
  angular.module("fleetviewApp").service("LayoutService", LayoutService);

  LayoutService.$inject = ["$rootScope"];

  function LayoutService($rootScope) {
    var leftPanelWidth = "0";

    var service = {
      getLeftPanelWidth: getLeftPanelWidth,
      openLeftHandPanel: openLeftHandPanel,
      closeLeftHandPanel: closeLeftHandPanel
    };

    return service;

    function getLeftPanelWidth() {
      return leftPanelWidth;
    }

    function openLeftHandPanel(width) {
      leftPanelWidth = width;
    }

    function closeLeftHandPanel() {
      leftPanelWidth = "0";
    }
  }
})(window.angular);


// WEBPACK FOOTER //
// ./app/layout/layoutService.js